import angular, {
    IComponentController,
    IComponentOptions,
    IScope,
} from 'angular';
import {
    IFontFamilyModel,
    IFontStyleModel,
    ScrollService,
} from '../../../tn.common';
import { PopoverService } from '../../../tn.popover/service.tn.popover';
import { ISeries, SeriesService } from '../../../tn.fonts/SeriesService';
import template from './style-page.html';

const FONT_STEPS = [120, 96, 72, 48, 40, 32, 24, 14, 8] as const;

export class StylePageController implements IComponentController {
    // bindings
    public family?: IFontFamilyModel;
    public style?: IFontStyleModel;

    // locals
    titleParams?: {
        familyName?: string;
        seriesName?: string;
    };
    series?: ISeries;
    specimenText = '';
    fontSizeSteps = FONT_STEPS.filter((step) => this._filterStep(step));
    variationSettings: Record<string, number> = {};
    buyPopover = this.$tnPopover.popoverXS(
        angular.element('.popover-styles-add')
    );

    static $inject = ['$scope', '$scroll', 'seriesService', '$tnPopover'];

    constructor(
        protected $scope: IScope,
        protected $scroll: ScrollService,
        protected seriesService: SeriesService,
        protected $tnPopover: PopoverService
    ) {}

    $onInit(): void {
        if (this.family?.canonical_series) {
            this.seriesService
                .getSeriesById(this.family.canonical_series)
                .then((series) => {
                    this.series = series;
                    this.titleParams = {
                        seriesName: series.slug,
                    };
                });
        }
        this.titleParams = {
            familyName: this.family?.slug,
        };
    }

    protected _filterStep(step: number): boolean {
        // if min or max is set, filter out steps that are outside of range
        return (
            (!this.style?.max_recommended_size ||
                step <= this.style.max_recommended_size) &&
            (!this.style?.min_recommended_size ||
                step >= this.style.min_recommended_size)
        );
    }
    variationSettingsChanged(variationSettings: Record<string, number>): void {
        this.variationSettings = variationSettings;
    }

    scrollTo(id: string): void {
        this.$scroll.to(id);
    }
}

export const StylePageComponent: IComponentOptions = {
    bindings: {
        family: '<',
        style: '<',
    },
    controller: StylePageController,
    controllerAs: 'vm',
    template,
};
